import React from 'react'
import InfoForm from '../../components/user/InfoForm'
import {useAuth} from '../../hooks/useAuth'
import ResetPasswordForm from '../../components/auth/resetPasswordForm'
import {Box, Card, Stack, Typography} from '@mui/material'
import {useTranslation} from 'react-i18next'
import {useFileUpload} from '../../hooks/useFileUpload'
import MirrorAccounts from '../../components/user/MirrorAccounts'
import ThirdPartyApps from '../../components/user/ThirdPartyApps'
import ThirdPartyUsers from '../../components/user/ThirdPartyUsers'


function Profile() {
    const {auth, updateUser, isLoading, isUpdateUserSuccess, user_avatar_uri} = useAuth()
    const {uploadImage, imageIsLoading, imageLoadingFailed} = useFileUpload()
    const {t} = useTranslation()

    const updateuserImage = async (file: File) => {

        if (!auth?.id) return

        try {
            let avatar_file = await uploadImage({file, isPublic: true, category: 'USER_AVATAR'})

            await updateUser({id: auth.id, avatar_file})

        } catch (e) {
            console.error(e)
        }


    }

    return (
        <Stack spacing={3}>
            <InfoForm avatar={user_avatar_uri} imageIsLoading={imageIsLoading} imageLoadingFailed={imageLoadingFailed}
                      handleImageChange={updateuserImage}
                      isLoading={isLoading} user={auth} onUpdate={updateUser}></InfoForm>
            <Card sx={{p: 3}}>
                <Typography variant='h6' mb={2}>{t('info:password')}</Typography>
                <ResetPasswordForm variant='outlined' isUpdateUserSuccess={isUpdateUserSuccess} spacing={5}
                                   fullWidth={false} md={6} isLoading={isLoading} onSubmitReset={(password: string) => {
                    updateUser({plain_password: password, id: auth?.id})
                }}></ResetPasswordForm>
            </Card>
            <Card sx={{p: 3}}>
                <ThirdPartyUsers></ThirdPartyUsers>
            </Card>
            <Box></Box>
            <ThirdPartyApps></ThirdPartyApps>
        </Stack>
    )
}

export default Profile